import React, { useState } from 'react';
// Image mapping: imgF1–imgF6 (see IMAGE_MAPPING in component or Untitled-1.md)
import imgF1 from '../assets/rooms/imgF1.webp';
import imgF2 from '../assets/rooms/imgF2.webp';
import imgF3 from '../assets/rooms/imgF3.webp';
import imgF4 from '../assets/rooms/imgF4.webp';
import imgF5 from '../assets/rooms/imgF5.webp';
import imgF6 from '../assets/rooms/imgF6.webp';
import imgF7 from '../assets/rooms/imgF7.webp';
import imgF8 from '../assets/rooms/imgF8.webp';
import imgF9 from '../assets/rooms/imgF9.webp';

const IMAGE_MAPPING = {
  imgF1: { src: imgF1, location: 'Hero section, left (row-span-2)' },
  imgF2: { src: imgF2, location: 'Hero section, top-right' },
  imgF3: { src: imgF3, location: 'Hero section, bottom-right' },
  imgF4: { src: imgF4, location: 'Rooms section, Deluxe Room card' },
  imgF5: { src: imgF5, location: 'Rooms section, Executive Suite card' },
  imgF6: { src: imgF6, location: 'Rooms section, Presidential Suite card' },
  imgF7: { src: imgF7, location: 'Rooms section, Card 4 (Deluxe placeholder)' },
  imgF8: { src: imgF8, location: 'Rooms section, Card 5 (Deluxe placeholder)' },
  imgF9: { src: imgF9, location: 'Rooms section, Card 6 (Deluxe placeholder)' },
};

const GALLERY_IMAGES = [imgCust1, imgCust2, imgCust3, imgCust4, imgCust5, imgCust6, imgCust7, imgCust8, imgCust9];

// Customer gallery: imgCust (1)–(9) in src/assets/
import imgCust1 from '../assets/imgCust (1).jpeg';
import imgCust2 from '../assets/imgCust (2).jpeg';
import imgCust3 from '../assets/imgCust (3).jpeg';
import imgCust4 from '../assets/imgCust (4).jpeg';
import imgCust5 from '../assets/imgCust (5).jpeg';
import imgCust6 from '../assets/imgCust (6).jpeg';
import imgCust7 from '../assets/imgCust (7).jpeg';
import imgCust8 from '../assets/imgCust (8).jpeg';
import imgCust9 from '../assets/imgCust (9).jpeg';

// Testimonial ellipse images: desktop test1–test3 + main (left→right), mobile test1–test4 + main (left→right). From src/assets/
import test1 from '../assets/test1.webp';
import test2 from '../assets/test2.webp';
import test3 from '../assets/test3.webp';
import test4 from '../assets/test4.webp';
import test5 from '../assets/test5.webp'; // currently unused but available if needed
import testMain from '../assets/test_main.webp'; // primary testimonial person (largest ellipse)

const TESTIMONIAL_IMAGES = {
  main: testMain,
  test1,
  test2,
  test3,
  test4,
  test5,
};

const MAKE_MY_TRIP_URL = 'https://www.makemytrip.com/hotels/vishwa_deva_home_stay-details-varanasi.html';
const YOUTUBE_WATCH_URL = 'https://youtu.be/jsZOZ6Ip_u4?si=CGz-cZtqZ78TpvbA';

const SkyLuxeTailwind = () => {
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState('1 Room, 2 Guest');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [contactName, setContactName] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [contactSending, setContactSending] = useState(false);
  const [showThankYouDialog, setShowThankYouDialog] = useState(false);
  const [contactError, setContactError] = useState(null);

  const openMakeMyTrip = () => {
    window.open(MAKE_MY_TRIP_URL, '_blank');
  };

  const handleBookNow = () => {
    openMakeMyTrip();
  };

  const handleFindNow = () => {
    openMakeMyTrip();
  };

  const handleContactNow = () => {
    openMakeMyTrip();
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactError(null);
    setContactSending(true);
    const apiBase = process.env.REACT_APP_API_URL || '';
    try {
      const res = await fetch(`${apiBase}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: contactName.trim(),
          phone: contactPhone.trim(),
          message: contactMessage.trim(),
          subject: 'Contact from Vishwa Deva Homestay website',
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        setContactName('');
        setContactPhone('');
        setContactMessage('');
        setShowThankYouDialog(true);
      } else {
        setContactError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setContactError('Unable to send. Check your connection or try again later.');
    } finally {
      setContactSending(false);
    }
  };

  return (
    <div className="font-poppins bg-bg-light">
      {/* Header */}
      <header className="bg-white sticky top-0 z-50 shadow-sm">
        <div className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px] flex items-center justify-between h-[88px]">
          {/* Logo */}
          <div className="text-primary font-semibold text-16 leading-[1.5em] text-center">
            Vishwa Deva Homestay
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="lg:hidden text-text-dark text-2xl"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <a href="#home" className="text-text-dark text-16 font-normal hover:text-primary transition-colors">Home</a>
            <a href="#rooms" className="text-text-dark text-16 font-normal hover:text-primary transition-colors">Rooms & Suites</a>
            <a href="#amenities" className="text-text-dark text-16 font-normal hover:text-primary transition-colors">Amenities</a>
            {/* Special Offers — hidden for now */}
            {/* <a href="#offers" className="text-text-dark text-16 font-normal hover:text-primary transition-colors">Special Offers</a> */}
            <a href="#about" className="text-text-dark text-16 font-normal hover:text-primary transition-colors">About Us</a>
            <a href="#contact" className="text-text-dark text-16 font-normal hover:text-primary transition-colors">Contact</a>
          </nav>

          {/* Login Button — hidden for now */}
          <button className="hidden bg-primary text-white px-6 py-2 rounded-42 text-10 font-medium hover:bg-primary-dark transition-colors">
            Login
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="lg:hidden bg-white border-t border-gray-200 py-4 px-4 flex flex-col gap-4">
            <a href="#home" onClick={() => setMobileMenuOpen(false)} className="text-text-dark text-16 font-normal py-2 border-b border-gray-100">Home</a>
            <a href="#rooms" onClick={() => setMobileMenuOpen(false)} className="text-text-dark text-16 font-normal py-2 border-b border-gray-100">Rooms & Suites</a>
            <a href="#amenities" onClick={() => setMobileMenuOpen(false)} className="text-text-dark text-16 font-normal py-2 border-b border-gray-100">Amenities</a>
            {/* Special Offers — hidden for now */}
            {/* <a href="#offers" onClick={() => setMobileMenuOpen(false)} className="text-text-dark text-16 font-normal py-2 border-b border-gray-100">Special Offers</a> */}
            <a href="#about" onClick={() => setMobileMenuOpen(false)} className="text-text-dark text-16 font-normal py-2 border-b border-gray-100">About Us</a>
            <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="text-text-dark text-16 font-normal py-2">Contact</a>
          </nav>
        )}
      </header>

      {/* Hero Section */}
      <section className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px] py-8 lg:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-primary font-normal text-20 leading-[1.5em] mb-2">
              Book Your Perfect Stay Today!
            </h2>
            <h1 className="text-text-dark font-medium text-34 lg:text-[64px] leading-[1.5em] mb-4">
              Discover Unparalleled Comfort & Luxury
            </h1>
            <p className="text-text-dark font-light text-18 leading-[1.5em] mb-8">
              Experience world-class hospitality, breathtaking views, and a relaxing atmosphere. Your dream vacation starts with just one click!
            </p>
            
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <button 
                onClick={handleBookNow}
                className="bg-primary text-white px-12 py-4 rounded-49 text-20 font-medium hover:bg-primary-dark transition-colors w-full sm:w-auto"
              >
                Book Now
              </button>
              <button
                type="button"
                onClick={() => window.open(YOUTUBE_WATCH_URL, '_blank')}
                className="flex items-center gap-2 text-text-dark text-20 font-medium hover:text-primary transition-colors bg-transparent border-none cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center">▶</span>
                Watch Video
              </button>
            </div>
          </div>

          {/* Right Images — imgF1, imgF2, imgF3 (data-image-id for remapping) */}
          <div className="flex-1 w-full max-w-[400px] lg:max-w-none">
            <div className="grid grid-cols-2 gap-2 h-[590px]">
              <div className="row-span-2 bg-gray-light rounded-lg overflow-hidden" data-image-id="imgF1">
                <img src={IMAGE_MAPPING.imgF1.src} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="bg-gray-light rounded-lg overflow-hidden" data-image-id="imgF2">
                <img src={IMAGE_MAPPING.imgF2.src} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="bg-gray-light rounded-lg overflow-hidden" data-image-id="imgF3">
                <img src={IMAGE_MAPPING.imgF3.src} alt="" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Form Section */}
      <section className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px] py-8">
        <div className="bg-white rounded-23 shadow-figma p-6 lg:p-6">
          <div className="flex flex-col lg:flex-row lg:flex-nowrap gap-4 lg:gap-3 lg:items-stretch">
            {/* Location - hidden; booking leads to MakeMyTrip */}
            <div className="hidden flex items-center gap-2 lg:gap-2 p-3 lg:py-3 lg:px-2 border border-gray-200 rounded-lg flex-1 min-w-0">
              <div className="w-6 h-7 lg:w-[26px] lg:h-[32px] flex-shrink-0">
                <svg className="w-full h-full" viewBox="0 0 29 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.5 0C6.5 0 0 6.5 0 14.5C0 25.5 14.5 37 14.5 37C14.5 37 29 25.5 29 14.5C29 6.5 22.5 0 14.5 0ZM14.5 19.5C11.7 19.5 9.5 17.3 9.5 14.5C9.5 11.7 11.7 9.5 14.5 9.5C17.3 9.5 19.5 11.7 19.5 14.5C19.5 17.3 17.3 19.5 14.5 19.5Z" fill="currentColor" className="text-primary"/>
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <label className="text-text-dark font-normal text-14 lg:text-16 leading-tight block mb-0.5">Location</label>
                <div className="text-text-dark font-light text-12 lg:text-14 leading-tight truncate">Washington D.C</div>
              </div>
            </div>

            {/* Check-In */}
            <div className="flex items-center gap-2 lg:gap-2 p-3 lg:py-3 lg:px-2 border border-gray-200 rounded-lg flex-1 min-w-0">
              <div className="w-6 h-7 lg:w-[26px] lg:h-[32px] flex-shrink-0">
                <svg className="w-full h-full" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="8" width="24" height="23" rx="2" stroke="currentColor" strokeWidth="2.5" fill="none" className="text-primary"/>
                  <line x1="6" y1="15" x2="30" y2="15" stroke="currentColor" strokeWidth="2.5" className="text-primary"/>
                  <line x1="12" y1="6" x2="12" y2="10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="text-primary"/>
                  <line x1="24" y1="6" x2="24" y2="10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="text-primary"/>
                  <circle cx="12" cy="22" r="1.5" fill="currentColor" className="text-primary"/>
                  <circle cx="18" cy="22" r="1.5" fill="currentColor" className="text-primary"/>
                  <circle cx="24" cy="22" r="1.5" fill="currentColor" className="text-primary"/>
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <label className="text-text-dark font-normal text-14 lg:text-16 leading-tight block mb-0.5">Check-In</label>
                <input 
                  type="date" 
                  className="text-text-dark font-light text-12 lg:text-14 leading-tight bg-transparent border-none outline-none w-full min-w-0"
                  value={checkIn}
                  onChange={(e) => setCheckIn(e.target.value)}
                />
              </div>
            </div>

            {/* Check-Out */}
            <div className="flex items-center gap-2 lg:gap-2 p-3 lg:py-3 lg:px-2 border border-gray-200 rounded-lg flex-1 min-w-0">
              <div className="w-6 h-7 lg:w-[26px] lg:h-[32px] flex-shrink-0">
                <svg className="w-full h-full" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="8" width="24" height="23" rx="2" stroke="currentColor" strokeWidth="2.5" fill="none" className="text-primary"/>
                  <line x1="6" y1="15" x2="30" y2="15" stroke="currentColor" strokeWidth="2.5" className="text-primary"/>
                  <line x1="12" y1="6" x2="12" y2="10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="text-primary"/>
                  <line x1="24" y1="6" x2="24" y2="10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="text-primary"/>
                  <circle cx="12" cy="22" r="1.5" fill="currentColor" className="text-primary"/>
                  <circle cx="18" cy="22" r="1.5" fill="currentColor" className="text-primary"/>
                  <circle cx="24" cy="22" r="1.5" fill="currentColor" className="text-primary"/>
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <label className="text-text-dark font-normal text-14 lg:text-16 leading-tight block mb-0.5">Check-Out</label>
                <input 
                  type="date" 
                  className="text-text-dark font-light text-12 lg:text-14 leading-tight bg-transparent border-none outline-none w-full min-w-0"
                  value={checkOut}
                  onChange={(e) => setCheckOut(e.target.value)}
                />
              </div>
            </div>

            {/* Rooms For */}
            <div className="flex items-center gap-2 lg:gap-2 p-3 lg:py-3 lg:px-2 border border-gray-200 rounded-lg flex-1 min-w-0">
              <div className="w-6 h-7 lg:w-[28px] lg:h-[32px] flex-shrink-0">
                <svg className="w-full h-full" viewBox="0 0 40 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4" y="12" width="32" height="21" rx="4" fill="currentColor" className="text-primary"/>
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <label className="text-text-dark font-normal text-14 lg:text-16 leading-tight block mb-0.5">Rooms For</label>
                <select 
                  className="text-text-dark font-light text-12 lg:text-14 leading-tight bg-transparent border-none outline-none w-full min-w-0"
                  value={guests}
                  onChange={(e) => setGuests(e.target.value)}
                >
                  <option>1 Room, 2 Guest</option>
                  <option>1 Room, 3 Guest</option>
                  <option>2 Rooms, 4 Guest</option>
                  <option>2 Rooms, 6 Guest</option>
                </select>
              </div>
            </div>

            {/* Find Now Button — equal width with other 4 elements; opens MakeMyTrip */}
            <div className="w-full flex justify-center items-stretch flex-1 min-w-0">
              <button 
                onClick={handleFindNow}
                className="bg-primary text-white px-6 lg:px-8 py-4 lg:py-3 rounded-14 text-16 lg:text-18 font-medium hover:bg-primary-dark transition-colors w-full whitespace-nowrap"
              >
                Find Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Rooms Section */}
      <section id="rooms" className="relative py-16 lg:py-24">
        {/* Background Rectangle */}
        <div className="absolute inset-0 bg-primary mt-[300px] lg:mt-[400px]"></div>
        
        <div className="relative max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px]">
          <h2 className="text-text-dark font-medium text-28 lg:text-[48px] leading-[1.5em] text-center mb-4">
            Exquisite Rooms & Suites Designed for Your Comfort
          </h2>
          <p className="text-text-dark font-light text-18 leading-[1.5em] text-center mb-12 max-w-2xl mx-auto">
            Whether you seek elegance, comfort, or a perfect blend of both.
          </p>

          {/* Rooms Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            {/* Deluxe Room — imgF4 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg">
              <div className="h-[246px] bg-gray-light overflow-hidden" data-image-id="imgF4">
                <img src={IMAGE_MAPPING.imgF4.src} alt="Deluxe Room" className="w-full h-full object-cover" />
              </div>
              <div className="bg-white p-5">
                <h3 className="text-text-dark font-medium text-24 leading-[1.5em] mb-3">Deluxe Room</h3>
                <p className="text-text-dark font-light text-16 leading-[1.5em] mb-4">
                  Perfect for Business travelers & weekend getaways
                </p>
                <div className="flex justify-between items-center">
                  <button onClick={openMakeMyTrip} className="bg-primary text-white px-6 py-3 rounded-12 text-16 font-medium hover:bg-primary-dark transition-colors">
                    View Detail
                  </button>
                  <span className="text-text-dark font-light text-16 leading-[1.5em] text-right whitespace-nowrap">
                    Starting from<br />750/night
                    <span className="block text-12 text-text-dark/80 mt-0.5">exact prices vary daily</span>
                  </span>
                </div>
              </div>
            </div>

            {/* Executive Suite — imgF5 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg">
              <div className="h-[246px] bg-gray-light overflow-hidden" data-image-id="imgF5">
                <img src={IMAGE_MAPPING.imgF5.src} alt="Executive Suite" className="w-full h-full object-cover" />
              </div>
              <div className="bg-white p-5">
                <h3 className="text-text-dark font-medium text-24 leading-[1.5em] mb-3">Executive Suite</h3>
                <p className="text-text-dark font-light text-16 leading-[1.5em] mb-4">
                  Perfect for Family people & extended stays
                </p>
                <div className="flex justify-between items-center">
                  <button onClick={openMakeMyTrip} className="bg-primary text-white px-6 py-3 rounded-12 text-16 font-medium hover:bg-primary-dark transition-colors">
                    View Detail
                  </button>
                  <span className="text-text-dark font-light text-16 leading-[1.5em] text-right whitespace-nowrap">
                    Starting from<br />750/night
                    <span className="block text-12 text-text-dark/80 mt-0.5">exact prices vary daily</span>
                  </span>
                </div>
              </div>
            </div>

            {/* Presidential Suite — imgF6 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg">
              <div className="h-[246px] bg-gray-light overflow-hidden" data-image-id="imgF6">
                <img src={IMAGE_MAPPING.imgF6.src} alt="Large Delux Room" className="w-full h-full object-cover" />
              </div>
              <div className="bg-white p-5">
                <h3 className="text-text-dark font-medium text-24 leading-[1.5em] mb-3">Large Delux Room</h3>
                <p className="text-text-dark font-light text-16 leading-[1.5em] mb-4">
                  VIP guests available with upto 5 beds perfect for senior citizens and family
                </p>
                <div className="flex justify-between items-center">
                  <button onClick={openMakeMyTrip} className="bg-primary text-white px-6 py-3 rounded-12 text-16 font-medium hover:bg-primary-dark transition-colors">
                    View Detail
                  </button>
                  <span className="text-text-dark font-light text-16 leading-[1.5em] text-right whitespace-nowrap">
                    Starting from<br />850/night
                    <span className="block text-12 text-text-dark/80 mt-0.5">exact prices vary daily</span>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 4 — Deluxe Room (imgF7) */}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg">
              <div className="h-[246px] bg-gray-light overflow-hidden" data-image-id="imgF7">
                <img src={IMAGE_MAPPING.imgF7.src} alt="Deluxe Room" className="w-full h-full object-cover" />
              </div>
              <div className="bg-white p-5">
                <h3 className="text-text-dark font-medium text-24 leading-[1.5em] mb-3">Deluxe Room</h3>
                <p className="text-text-dark font-light text-16 leading-[1.5em] mb-4">
                Perfect for Budget travellers & many person stays
                </p>
                <div className="flex justify-between items-center">
                  <button onClick={openMakeMyTrip} className="bg-primary text-white px-6 py-3 rounded-12 text-16 font-medium hover:bg-primary-dark transition-colors">
                    View Detail
                  </button>
                  <span className="text-text-dark font-light text-16 leading-[1.5em] text-right whitespace-nowrap">
                    Starting from<br />700/night
                    <span className="block text-12 text-text-dark/80 mt-0.5">exact prices vary daily</span>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 5 — Deluxe Room (imgF8) */}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg">
              <div className="h-[246px] bg-gray-light overflow-hidden" data-image-id="imgF8">
                <img src={IMAGE_MAPPING.imgF8.src} alt="Deluxe Room" className="w-full h-full object-cover" />
              </div>
              <div className="bg-white p-5">
                <h3 className="text-text-dark font-medium text-24 leading-[1.5em] mb-3">Deluxe Room</h3>
                <p className="text-text-dark font-light text-16 leading-[1.5em] mb-4">
                  Perfect for Budget travellers & extended stays
                </p>
                <div className="flex justify-between items-center">
                  <button onClick={openMakeMyTrip} className="bg-primary text-white px-6 py-3 rounded-12 text-16 font-medium hover:bg-primary-dark transition-colors">
                    View Detail
                  </button>
                  <span className="text-text-dark font-light text-16 leading-[1.5em] text-right whitespace-nowrap">
                    Starting from<br />700/night
                    <span className="block text-12 text-text-dark/80 mt-0.5">exact prices vary daily</span>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 6 — Deluxe Room (imgF9) */}
            <div className="bg-white rounded-lg overflow-hidden shadow-lg">
              <div className="h-[246px] bg-gray-light overflow-hidden" data-image-id="imgF9">
                <img src={IMAGE_MAPPING.imgF9.src} alt="Deluxe Room" className="w-full h-full object-cover" />
              </div>
              <div className="bg-white p-5">
                <h3 className="text-text-dark font-medium text-24 leading-[1.5em] mb-3">Deluxe Room</h3>
                <p className="text-text-dark font-light text-16 leading-[1.5em] mb-4">
                Perfect for Budget travellers & extended stays
                </p>
                <div className="flex justify-between items-center">
                  <button onClick={openMakeMyTrip} className="bg-primary text-white px-6 py-3 rounded-12 text-16 font-medium hover:bg-primary-dark transition-colors">
                    View Detail
                  </button>
                  <span className="text-text-dark font-light text-16 leading-[1.5em] text-right whitespace-nowrap">
                    Starting from<br />850/night
                    <span className="block text-12 text-text-dark/80 mt-0.5">exact prices vary daily</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* View All Button — opens MakeMyTrip */}
          <div className="text-center">
            <button onClick={openMakeMyTrip} className="border-2 border-white text-white bg-transparent px-16 py-6 rounded-49 text-24 font-medium hover:bg-white hover:text-primary transition-colors">
              View All Room & Suite
            </button>
          </div>
        </div>
      </section>

      {/* Amenities Section */}
      <section id="amenities" className="py-16 lg:py-24 bg-white">
        <div className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px]">
          <h2 className="text-text-dark font-medium text-28 lg:text-[48px] leading-[1.5em] text-center mb-4">
            Luxury Beyond Your Room  Enjoy Exclusive Amenities
          </h2>
          <p className="text-text-dark font-light text-18 leading-[1.5em] text-center mb-12 max-w-2xl mx-auto">
            Indulge in world-class amenities, from rejuvenating spa treatments.
          </p>

          {/* Amenities Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {/* Tourist Attraction */}
            {/* <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="60" cy="60" r="50" fill="#7C6A46"/>
                  <path d="M60 25L70 50H90L73 62L80 87L60 72L40 87L47 62L30 50H50L60 25Z" fill="white"/>
                  <circle cx="60" cy="60" r="15" fill="white"/>
                  <circle cx="60" cy="60" r="8" fill="#7C6A46"/>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Tourist Attraction</h3>
            </div> */}

            {/* Taxi Service */}
            <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="20" y="50" width="80" height="35" rx="8" fill="#7C6A46"/>
                  <rect x="25" y="45" width="70" height="30" rx="6" fill="white"/>
                  <circle cx="35" cy="85" r="8" fill="#7C6A46"/>
                  <circle cx="35" cy="85" r="4" fill="white"/>
                  <circle cx="85" cy="85" r="8" fill="#7C6A46"/>
                  <circle cx="85" cy="85" r="4" fill="white"/>
                  <rect x="45" y="30" width="30" height="15" rx="3" fill="#7C6A46"/>
                  <rect x="50" y="33" width="8" height="9" fill="white"/>
                  <rect x="62" y="33" width="8" height="9" fill="white"/>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Taxi Service</h3>
            </div>

            {/* Pure Veg Food - Fine Dining Icon */}
            <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="60" cy="60" r="45" fill="#7C6A46"/>
                  <circle cx="60" cy="50" r="25" fill="white"/>
                  <ellipse cx="60" cy="75" rx="30" ry="15" fill="white"/>
                  <path d="M40 50C40 50 45 35 60 35C75 35 80 50 80 50" stroke="#7C6A46" strokeWidth="3" fill="none"/>
                  <line x1="45" y1="55" x2="50" y2="65" stroke="#7C6A46" strokeWidth="2"/>
                  <line x1="60" y1="55" x2="60" y2="65" stroke="#7C6A46" strokeWidth="2"/>
                  <line x1="75" y1="55" x2="70" y2="65" stroke="#7C6A46" strokeWidth="2"/>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Pure Veg Food</h3>
            </div>

            {/* Priority Room Service - VIP Services Icon */}
            <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="60" cy="35" r="15" fill="#7C6A46"/>
                  <circle cx="60" cy="35" r="10" fill="white"/>
                  <path d="M35 55C35 55 40 50 60 50C80 50 85 55 85 55L85 90C85 90 80 95 60 95C40 95 35 90 35 90L35 55Z" fill="#7C6A46"/>
                  <rect x="45" y="60" width="30" height="25" fill="white"/>
                  <path d="M50 20L55 30L45 30L50 20Z" fill="#7C6A46"/>
                  <path d="M60 18L63 25L57 25L60 18Z" fill="white"/>
                  <circle cx="60" cy="72" r="8" fill="#7C6A46"/>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Priority Room Service</h3>
            </div>

            {/* Secured Parking */}
            <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="25" y="50" width="70" height="45" rx="5" fill="#7C6A46"/>
                  <rect x="30" y="55" width="60" height="35" rx="3" fill="white"/>
                  <rect x="50" y="35" width="20" height="20" rx="3" fill="#7C6A46"/>
                  <circle cx="60" cy="45" r="6" fill="white"/>
                  <rect x="57" y="45" width="6" height="8" fill="white"/>
                  <path d="M60 42V48M57 45H63" stroke="#7C6A46" strokeWidth="2" strokeLinecap="round"/>
                  <text x="60" y="78" fontFamily="Arial" fontSize="24" fontWeight="bold" fill="#7C6A46" textAnchor="middle">P</text>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Secured Parking</h3>
            </div>

            {/* Family Friendly */}
            <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="40" cy="30" r="10" fill="#7C6A46"/>
                  <circle cx="40" cy="30" r="6" fill="white"/>
                  <path d="M25 45C25 45 28 42 40 42C52 42 55 45 55 45L55 75L25 75L25 45Z" fill="#7C6A46"/>
                  <circle cx="80" cy="30" r="10" fill="#7C6A46"/>
                  <circle cx="80" cy="30" r="6" fill="white"/>
                  <path d="M65 45C65 45 68 42 80 42C92 42 95 45 95 45L95 75L65 75L65 45Z" fill="#7C6A46"/>
                  <circle cx="60" cy="65" r="8" fill="white"/>
                  <circle cx="60" cy="65" r="5" fill="#7C6A46"/>
                  <path d="M50 78C50 78 52 75 60 75C68 75 70 78 70 78L70 95L50 95L50 78Z" fill="white"/>
                  <path d="M30 50L50 50L50 70L30 70L30 50Z" fill="white"/>
                  <path d="M70 50L90 50L90 70L70 70L70 50Z" fill="white"/>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Family Friendly</h3>
            </div>

            {/* Central Location */}
            <div className="bg-white rounded-lg shadow-amenity p-8 text-center hover:transform hover:-translate-y-1 transition-transform">
              <div className="h-[148px] flex items-center justify-center mb-4">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="60" cy="60" r="45" fill="#7C6A46"/>
                  <circle cx="60" cy="60" r="35" fill="white"/>
                  <circle cx="60" cy="60" r="25" fill="#7C6A46"/>
                  <circle cx="60" cy="60" r="15" fill="white"/>
                  <circle cx="60" cy="60" r="8" fill="#7C6A46"/>
                  <line x1="60" y1="15" x2="60" y2="35" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  <line x1="60" y1="85" x2="60" y2="105" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  <line x1="15" y1="60" x2="35" y2="60" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  <line x1="85" y1="60" x2="105" y2="60" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="text-text-dark font-medium text-16 leading-[1.5em]">Central Location</h3>
            </div>
          </div>

          {/* Contact Now Button — opens MakeMyTrip */}
          <div className="text-center">
            <button onClick={handleContactNow} className="bg-primary text-white px-16 py-5 rounded-49 text-20 font-medium hover:bg-primary-dark transition-colors">
              Contact Now
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 lg:py-24">
        <div className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px]">
          <div className="bg-primary rounded-lg p-8 lg:p-16 text-white">
            <h2 className="font-medium text-28 lg:text-[48px] leading-[1.5em] text-center mb-4">
              What Our Guests Say Unforgettable Experiences Await!
            </h2>
            <p className="font-light text-18 leading-[1.5em] text-center mb-12 max-w-2xl mx-auto">
              Real stories from real travelers. Discover why guests keep coming back to our luxurious haven.
            </p>

            <div className="max-w-5xl mx-auto">
              {/* Row: ellipses left, testimonial text right; vertically centered */}
              <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10 lg:flex-nowrap">
                {/* Mobile: 5 ellipses — sizes decrease uniformly from center (44, 56, 72, 56, 44); same horizontal z; test1–test4 + main */}
                <div className="flex lg:hidden flex-col items-center flex-shrink-0 w-full px-4">
                  <div className="flex items-center justify-center min-h-[72px]">
                    <div className="w-11 h-11 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-0 -mr-3" data-testimonial-id="test1">
                      <img src={TESTIMONIAL_IMAGES.test1} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="w-14 h-14 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-10 -mr-3" data-testimonial-id="test2">
                      <img src={TESTIMONIAL_IMAGES.test2} alt="" className="w-full h-full object-cover" />
                    </div>
                    {/* Center (largest) — main testimonial person */}
                    <div className="w-[72px] h-[72px] rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-20 -mx-2" data-testimonial-id="main">
                      <img src={TESTIMONIAL_IMAGES.main} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="w-14 h-14 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-10 -ml-3" data-testimonial-id="test4">
                      <img src={TESTIMONIAL_IMAGES.test3} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="w-11 h-11 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-0 -ml-3" data-testimonial-id="test5">
                      <img src={TESTIMONIAL_IMAGES.test4} alt="" className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <span className="text-16 font-medium text-white whitespace-nowrap mt-2"></span>
                </div>

                {/* Desktop: 4 ellipses (same horizontal line) + Olivia C. below; test1–test3 + main (largest, rightmost) */}
                <div className="hidden lg:flex flex-col items-center flex-shrink-0">
                  <div className="flex items-center min-h-[96px]">
                    <div className="w-12 h-12 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-0 -mr-[14px]" data-testimonial-id="test1">
                      <img src={TESTIMONIAL_IMAGES.test1} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="w-16 h-16 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-10 -mr-[18px]" data-testimonial-id="test2">
                      <img src={TESTIMONIAL_IMAGES.test2} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="w-20 h-20 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-20 -mr-[22px]" data-testimonial-id="test3">
                      <img src={TESTIMONIAL_IMAGES.test3} alt="" className="w-full h-full object-cover" />
                    </div>
                    {/* Largest ellipse — main testimonial person */}
                    <div className="w-24 h-24 rounded-full bg-white border-2 border-white overflow-hidden flex-shrink-0 z-30" data-testimonial-id="main">
                      <img src={TESTIMONIAL_IMAGES.main} alt="" className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <span className="text-16 font-medium text-white whitespace-nowrap mt-2"></span>
                </div>

                {/* Right: testimonial text block; on mobile full width + centered below ellipses */}
                <div className="relative flex-1 min-w-0 pl-0 lg:pl-2 w-full lg:w-auto text-center lg:text-left">
                  <div className="relative text-center lg:text-left px-2">
                    <div className="absolute left-0 top-0 lg:-left-1 opacity-30">
                      <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 24C8 20 10 16 14 12C14 12 12 14 12 16C12 18.2 13.8 20 16 20C18.2 20 20 18.2 20 16C20 13.8 18.2 12 16 12C12 12 8 16 8 24Z" fill="white"/>
                        <path d="M20 24C20 20 22 16 26 12C26 12 24 14 24 16C24 18.2 25.8 20 28 20C30.2 20 32 18.2 32 16C32 13.8 30.2 12 28 12C24 12 20 16 20 24Z" fill="white"/>
                      </svg>
                    </div>
                    <p className="font-light text-16 lg:text-18 leading-[1.6em] mb-4 italic pl-8 lg:pl-6 pr-8 lg:pr-0 relative z-10">
                    Place was present and it's a cozy home stay in very pocket friendly rate. The owner is co operative and very helpful. You get hot water facility as well. Owner is really helpful and humble person who will help you with all requirements. Please book it online or call hotel directly. Thank you once again look forward to visit again.
                    </p>
                    <div className="absolute right-0 top-0 lg:top-auto lg:bottom-0 opacity-30 transform rotate-180">
                      <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 24C8 20 10 16 14 12C14 12 12 14 12 16C12 18.2 13.8 20 16 20C18.2 20 20 18.2 20 16C20 13.8 18.2 12 16 12C12 12 8 16 8 24Z" fill="white"/>
                        <path d="M20 24C20 20 22 16 26 12C26 12 24 14 24 16C24 18.2 25.8 20 28 20C30.2 20 32 18.2 32 16C32 13.8 30.2 12 28 12C24 12 20 16 20 24Z" fill="white"/>
                      </svg>
                    </div>
                  </div>
                  <div className="flex gap-2 mb-4 justify-center lg:justify-start">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="text-gold text-xl">★</span>
                    ))}
                  </div>
                  <h3 className="text-20 font-medium mb-1">Ketan S.</h3>
                  <p className="text-14 font-light">Mumbai</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="relative min-h-[800px] lg:min-h-[1000px]">
        <div className="absolute inset-0 bg-gray-light"></div>
        <div className="absolute inset-0 bg-brown-overlay"></div>
        
        <div className="relative max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px] py-16 lg:py-24 text-white">
          <h2 className="font-medium text-28 lg:text-[48px] leading-[1.5em] text-center lg:text-left mb-4">
            A Legacy of Hospitality – Our Story
          </h2>
          <p className="font-light text-18 leading-[1.5em] text-center lg:text-left mb-12 max-w-2xl">
            Founded on passion and excellence, we take pride in providing world-class hospitality with a personal touch.
          </p>

          <div className="space-y-8">
            <div>
              <h3 className="text-24 font-medium mb-4">Who We Are</h3>
              <p className="font-light text-18 leading-[1.5em]">
                At Vishwa Deva Homestay, we believe that a truly remarkable stay is more than just luxurious accommodations—it's about creating unforgettable experiences. Established with a vision to redefine hospitality, our hotel blends modern elegance with warm, personalized service to ensure every guest feels at home.
              </p>
            </div>

            <div>
              <h3 className="text-24 font-medium mb-4">Our Mission</h3>
              <p className="font-light text-18 leading-[1.5em]">
                Our mission is simple: to provide exceptional hospitality that exceeds expectations. Whether you're here for a relaxing getaway, a business trip, or a special occasion, we are committed to offering unparalleled comfort, world-class amenities, and a seamless experience from check-in to check-out.
              </p>
            </div>

            <div>
              <h3 className="text-24 font-medium mb-4">Our Commitment</h3>
              <p className="font-light text-18 leading-[1.5em]">
                Sustainability and responsible tourism are at the core of what we do. We take pride in our eco-friendly initiatives, from energy-efficient designs to locally sourced ingredients in our restaurants. At Vishwa Deva Homestay, we don't just offer a place to relax—we provide a home away from home, where luxury meets comfort in the most extraordinary way.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 lg:py-24 bg-white">
        <div className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px]">
          <h2 className="text-text-dark font-medium text-28 lg:text-[48px] leading-[1.5em] text-center mb-4">
            Get in Touch – We're Here for You!
          </h2>
          <p className="text-text-dark font-light text-18 leading-[1.5em] text-center mb-12 max-w-2xl mx-auto">
            Have questions? Need assistance with your booking?
          </p>

          <form onSubmit={handleContactSubmit} className="max-w-md mx-auto space-y-6">
            <div>
              <input 
                type="text" 
                placeholder="Full Name"
                value={contactName}
                onChange={(e) => setContactName(e.target.value)}
                required
                minLength={2}
                maxLength={100}
                className="w-full px-6 py-5 border-2 border-primary rounded-22 text-22 font-medium placeholder:text-text-dark placeholder:opacity-70 focus:outline-none focus:border-primary-dark"
              />
            </div>
            <div>
              <input 
                type="tel" 
                placeholder="Phone Number"
                value={contactPhone}
                onChange={(e) => setContactPhone(e.target.value)}
                required
                className="w-full px-6 py-5 border-2 border-primary rounded-22 text-22 font-medium placeholder:text-text-dark placeholder:opacity-70 focus:outline-none focus:border-primary-dark"
              />
            </div>
            <div>
              <textarea 
                placeholder="Message"
                rows="4"
                value={contactMessage}
                onChange={(e) => setContactMessage(e.target.value)}
                required
                minLength={10}
                maxLength={1000}
                className="w-full px-6 py-5 border-2 border-primary rounded-22 text-22 font-medium placeholder:text-text-dark placeholder:opacity-70 focus:outline-none focus:border-primary-dark resize-vertical"
              />
            </div>
            {contactError && (
              <p className="text-red-600 text-14">{contactError}</p>
            )}
            <button 
              type="submit"
              disabled={contactSending}
              className="w-full bg-primary text-white px-12 py-5 rounded-19 text-20 font-medium hover:bg-primary-dark transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {contactSending ? 'Sending…' : 'Send Message'}
            </button>
          </form>

          {/* Thank You dialog — color scheme (primary 7C6A46) */}
          {showThankYouDialog && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" onClick={() => setShowThankYouDialog(false)}>
              <div className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden border-2 border-primary" onClick={(e) => e.stopPropagation()}>
                <div className="bg-primary text-white px-8 py-6 text-center">
                  <h3 className="text-24 font-semibold">Thank You</h3>
                </div>
                <div className="px-8 py-6 text-center">
                  <p className="text-text-dark text-18 leading-relaxed mb-6">
                    One of our representatives will get in touch soon.
                  </p>
                  <button
                    type="button"
                    onClick={() => setShowThankYouDialog(false)}
                    className="bg-primary text-white px-8 py-3 rounded-14 text-16 font-medium hover:bg-primary-dark transition-colors"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Footer — original VSL/sales page footer (contact, OTA, legal, phone); plus customer photo gallery replacing idle gray block */}
      <footer className="bg-primary text-white">
        {/* Customer Photo Gallery Section (replaces idle gray div below contact form) */}
        <section className="relative py-16 bg-bg-light">
          {/* Background primary rectangle behind cards — starts at top to avoid gray strip above */}
          <div className="absolute inset-0 bg-primary"></div>
          <div className="relative max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px]">
            <h2 className="text-white text-28 lg:text-[32px] font-semibold mb-4 text-center lg:text-left">
              Moments Shared by Our Guests
            </h2>
            <p className="text-white/90 text-14 lg:text-18 mb-8 max-w-2xl mx-auto lg:mx-0 text-center lg:text-left">
              A curated gallery of feedback captured by our guests just like you, during their stay at Vishwa Deva Homestay.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Photo 1 – imgCust (1) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-1">
                  <img src={GALLERY_IMAGES[0]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Cozy Stays</h3>
                  <p className="text-text-dark text-14">Warm and welcoming rooms captured by our guests.</p>
                </div>
              </div>

              {/* Photo 2 – imgCust (2) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-2">
                  <img src={GALLERY_IMAGES[1]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Elegant Interiors</h3>
                  <p className="text-text-dark text-14">Thoughtfully designed spaces for comfort and style.</p>
                </div>
              </div>

              {/* Photo 3 – imgCust (3) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-3">
                  <img src={GALLERY_IMAGES[2]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Family Moments</h3>
                  <p className="text-text-dark text-14">Memorable stays with family and friends.</p>
                </div>
              </div>

              {/* Photo 4 – imgCust (4) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-4">
                  <img src={GALLERY_IMAGES[3]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">City Views</h3>
                  <p className="text-text-dark text-14">Beautiful glimpses of the city from our property.</p>
                </div>
              </div>

              {/* Photo 5 – imgCust (5) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-5">
                  <img src={GALLERY_IMAGES[4]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Relaxing Evenings</h3>
                  <p className="text-text-dark text-14">Evening vibes captured by our guests.</p>
                </div>
              </div>

              {/* Photo 6 – imgCust (6) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-6">
                  <img src={GALLERY_IMAGES[5]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Comfort &amp; Care</h3>
                  <p className="text-text-dark text-14">Snapshots of our hospitality in action.</p>
                </div>
              </div>

              {/* Photo 7 – imgCust (7) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-7">
                  <img src={GALLERY_IMAGES[6]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Modern Amenities</h3>
                  <p className="text-text-dark text-14">Guest-approved amenities for a seamless stay.</p>
                </div>
              </div>

              {/* Photo 8 – imgCust (8) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-8">
                  <img src={GALLERY_IMAGES[7]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Peaceful Environment</h3>
                  <p className="text-text-dark text-14">Little details that make every stay special.</p>
                </div>
              </div>

              {/* Photo 9 – imgCust (9) */}
              <div className="bg-white rounded-lg overflow-hidden shadow-amenity">
                <div className="h-48 sm:h-56 lg:h-64 bg-gray-light overflow-hidden" data-image-id="imgCust-9">
                  <img src={GALLERY_IMAGES[8]} alt="Guest stay photo" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-text-dark font-medium text-16 mb-1">Guest Highlights</h3>
                  <p className="text-text-dark text-14">Real experiences from real guests.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="py-16 lg:py-24">
          <div className="max-w-desktop mx-auto px-4 sm:px-8 lg:px-[110px]">
            {/* Original landing page footer: brand, contact, OTA links, legal, copyright */}
            <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
              <div className="mb-8">
                <h2 className="text-28 font-semibold mb-2 text-white">Vishwa Deva Homestay</h2>
                <p className="text-white/90 text-16 font-light leading-relaxed">
                  Best family hotel near Kashi Vishwanath Temple, Varanasi. 4.7/5 rated by 260+ guests.
                </p>
              </div>

              {/* Contact — direct phone call */}
              <div className="mb-8">
                <h4 className="text-18 font-semibold mb-3 text-white">Contact Us</h4>
                <a href="tel:+919415600200" className="inline-flex items-center gap-2 bg-white text-primary px-6 py-3 rounded-lg font-semibold text-16 hover:bg-white/90 transition-colors">
                  📞 Call +919580110340
                </a>
              </div>

              {/* OTA / Find us on */}
              <div className="mb-8">
                <h4 className="text-18 font-semibold mb-4 text-white">Find us on</h4>
                <div className="flex flex-wrap justify-center gap-3">
                  <a href="https://share.google/pyAfGwDGOXibRON0k" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-14 font-medium transition-colors border border-white/20">
                    🔍 Google Profile
                  </a>
                  <a href="https://www.makemytrip.com/hotels/vishwa_deva_home_stay-details-varanasi.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-14 font-medium transition-colors border border-white/20">
                    ✈️ MakeMyTrip
                  </a>
                  <a href="https://www.expedia.co.in/Varanasi-Hotels-Vishwa-Deva-Homestay.h119046992.Hotel-Information" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-14 font-medium transition-colors border border-white/20">
                    🌐 Expedia
                  </a>
                  <a href="https://www.agoda.com/en-in/vishwa-deva-homestay-h37328295/hotel/varanasi-in.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-14 font-medium transition-colors border border-white/20">
                    🏨 Agoda
                  </a>
                  <a href="https://www.goibibo.com/hotels/vishwa-deva-home-stay-hotel-in-varanasi-7884503547941569550/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-14 font-medium transition-colors border border-white/20">
                    🚀 Goibibo
                  </a>
                  <a href="https://yatradham.org/varanasi-vishwa-deva-atithi-griha.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-14 font-medium transition-colors border border-white/20">
                    🛕 YatraDham
                  </a>
                </div>
              </div>

              {/* Legal links */}
              <div className="flex flex-wrap justify-center gap-6 mb-6">
                <a href="/privacy-policy" className="text-white/90 hover:text-white text-16 font-light transition-colors">Privacy Policy</a>
                <a href="/disclaimer" className="text-white/90 hover:text-white text-16 font-light transition-colors">Disclaimer</a>
                <a href="/terms-of-service" className="text-white/90 hover:text-white text-16 font-light transition-colors">Terms of Service</a>
              </div>
              <p className="text-white/80 text-14 font-light">© 2026 Vishwa Deva Homestay. All rights reserved.</p>
            </div>

            {/* COMMENTED OUT: Vishwa Deva Homestay 4-column footer (Quick Links, Explore Our Hotel, Guest Resources, Community & Engagement) — uncomment to restore */}
            {/* <div className="text-center mb-16">
              <h2 className="text-38 font-semibold mb-8">Vishwa Deva Homestay</h2>
              <div className="flex justify-center gap-4 mb-4">
                {['📘', '🐦', '💼', '📷'].map((icon, i) => (
                  <a key={i} href="#" className="text-2xl hover:opacity-80 transition-opacity">{icon}</a>
                ))}
              </div>
              <div className="flex justify-center gap-6 flex-wrap">
                {['Instagram', 'Twitter', 'LinkedIn', 'Facebook'].map((social, i) => (
                  <a key={i} href="#" className="text-16 font-light hover:opacity-80 transition-opacity">{social}</a>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 text-center lg:text-left">
              <div>
                <h3 className="text-20 font-medium mb-6">Quick Links</h3>
                {['How to Book', 'Travel Guides', 'Guest Policies', 'Mobile App', 'Support Center'].map((link, i) => (
                  <a key={i} href="#" className="block text-16 font-light mb-3 hover:opacity-80 transition-opacity">{link}</a>
                ))}
              </div>
              <div>
                <h3 className="text-20 font-medium mb-6">Explore Our Hotel</h3>
                {['Room Categories', 'Exclusive Deals', 'Dining & Lounge', 'Spa & Wellness', 'Events & Weddings'].map((link, i) => (
                  <a key={i} href="#" className="block text-16 font-light mb-3 hover:opacity-80 transition-opacity">{link}</a>
                ))}
              </div>
              <div>
                <h3 className="text-20 font-medium mb-6">Guest Resources</h3>
                {['FAQ & Help Center', 'Travel Tips & Blogs', 'Customer Service', 'Accessibility Features', 'Latest Updates'].map((link, i) => (
                  <a key={i} href="#" className="block text-16 font-light mb-3 hover:opacity-80 transition-opacity">{link}</a>
                ))}
              </div>
              <div>
                <h3 className="text-20 font-medium mb-6">Community & Engagement</h3>
                {['Loyalty Program', 'Hotel Reviews', 'Sustainability Efforts', 'Careers & Partnerships', 'Local Attractions'].map((link, i) => (
                  <a key={i} href="#" className="block text-16 font-light mb-3 hover:opacity-80 transition-opacity">{link}</a>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SkyLuxeTailwind;
